

import React, { useContext } from 'react';
import CloseIcon from '@nokia-csf-uxr/ccfk-assets/CloseIcon';
import { getContext } from 'common';
import IconButton from 'components/IconButton';
import { SelectItemBasicContext } from './SelectItemBasic';
import { SelectItemSearchableContext } from './SelectItemSearchable';

export interface SelectItemClearButtonProps extends React.ComponentPropsWithRef<'button'> {
  /** An Icon component. */
  children?: React.ReactElement;
  /** @ignore */
  onClick?: React.MouseEventHandler;
  /** @ignore */
  onKeyDown?: React.KeyboardEventHandler;
}

/** A button to use as the clear button on the SelectItem. Any other props than `children` will be provided to the <IconButton /> component. */
const SelectItemClearButton = React.forwardRef<HTMLElement, SelectItemClearButtonProps>((props: SelectItemClearButtonProps, ref) => getContext(({ theme }) => {
  const {
    children,
    ...otherProps
  } = props;
  const selectItemBasicContext = useContext(SelectItemBasicContext);
  const selectItemSearchableContext = useContext(SelectItemSearchableContext);

  const handleKeyDown = (event) => {
    const { onKeyDown } = props;
    event.stopPropagation();
    onKeyDown && onKeyDown(event);
  };

  const handleOnClick = (event) => {
    const { onClick } = props;
    // stopPropagation so the SelectItem does not get the click event
    event.preventDefault();
    event.stopPropagation();
    onClick && onClick(event);
  };

  return (
    <IconButton
      size="small"
      ref={ref}
      theme={theme.ICON_BUTTON.FLAT}
      tabIndex={0}
      disabled={selectItemBasicContext.disabled || selectItemSearchableContext.disabled}
      {...otherProps}
      onKeyDown={handleKeyDown}
      onClick={handleOnClick}
    >
      {children}
    </IconButton>);
}));

SelectItemClearButton.defaultProps = {
  children: <CloseIcon />,
  onClick: undefined,
  onKeyDown: undefined,
};
SelectItemClearButton.displayName = 'SelectItemClearButton';
export default SelectItemClearButton;
